import React from "react";
// @mui/core components
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";

const styles = {
  grid: {
    marginRight: "-15px",
    marginLeft: "-15px",
    width: "auto"
  }
};

const useStyles = makeStyles(styles);

interface GridContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export default function GridContainer(props: GridContainerProps) {
  const classes = useStyles();
  const { children, className = "", ...rest } = props;
  return (
    <Grid container {...rest} className={classes.grid + " " + className}>
      {children}
    </Grid>
  );
}
